import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
const CENTER = {
  x: 200,
  y: 200
};
const nodes = [{
  x: 200,
  y: 36
}, {
  x: 318,
  y: 78
}, {
  x: 368,
  y: 188
}, {
  x: 336,
  y: 304
}, {
  x: 228,
  y: 366
}, {
  x: 108,
  y: 342
}, {
  x: 38,
  y: 236
}, {
  x: 62,
  y: 116
}, {
  x: 142,
  y: 70
}, {
  x: 292,
  y: 142
}, {
  x: 302,
  y: 256
}, {
  x: 126,
  y: 272
}, {
  x: 106,
  y: 168
}];
const edges: Array<[number, number]> = [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 6], [6, 7], [7, 8], [8, 0], [0, 9], [9, 2], [2, 10], [10, 4], [5, 11], [11, 6], [7, 12], [12, 8], [9, 10], [11, 12]];
const spokes = [9, 10, 11, 12, 0, 3, 6];
export function NetworkOrb() {
  const reduce = useReducedMotion();
  return <svg viewBox="0 0 400 400" className="h-full w-full" aria-hidden="true" focusable="false" data-id="element-197" data-mp="3klcmkmquxj">
      <defs data-id="element-198" data-mp="ntoiqc785yg3">
        <radialGradient id="orb-core" cx="50%" cy="45%" r="55%" data-id="element-199" data-mp="nt6fgvm5ajyo">
          <stop offset="0%" stopColor="#c4b5fd" data-id="element-200" data-mp="skess2qliph4" />
          <stop offset="45%" stopColor="#6366f1" data-id="element-201" data-mp="sm80zmguxhr8" />
          <stop offset="100%" stopColor="#1e1b4b" data-id="element-202" data-mp="2131ouprvamha" />
        </radialGradient>
        <filter id="orb-blur" x="-50%" y="-50%" width="200%" height="200%" data-id="element-203" data-mp="21175vh05p4fu">
          <feGaussianBlur stdDeviation="22" data-id="element-204" data-mp="1x3svhm0qoqm9" />
        </filter>
      </defs>

      {edges.map(([a, b]) => <line key={`e-${a}-${b}`} x1={nodes[a].x} y1={nodes[a].y} x2={nodes[b].x} y2={nodes[b].y} stroke="#3b82f6" strokeOpacity="0.28" strokeWidth="1" data-id="element-205" data-mp="2avfuhtm2gd8q" />)}
      {spokes.map(i => <line key={`s-${i}`} x1={nodes[i].x} y1={nodes[i].y} x2={CENTER.x} y2={CENTER.y} stroke="#8b5cf6" strokeOpacity="0.3" strokeWidth="1" strokeDasharray="3 5" data-id="element-206" data-mp="2fsppdos85h3y" />)}

      {!reduce && spokes.map((i, idx) => <motion.circle key={`p-${i}`} r="2.5" fill="#22d3ee" initial={{
      cx: nodes[i].x,
      cy: nodes[i].y,
      opacity: 0
    }} animate={{
      cx: [nodes[i].x, CENTER.x],
      cy: [nodes[i].y, CENTER.y],
      opacity: [0, 1, 0]
    }} transition={{
      duration: 2.6,
      repeat: Infinity,
      ease: 'linear',
      delay: idx * 0.45
    }} data-id="element-207" data-mp="2or1cvhxsnys6" data-mpi={idx} />)}

      {nodes.map((n, i) => <motion.circle key={`n-${i}`} cx={n.x} cy={n.y} r={i % 3 === 0 ? 4 : 3} fill={i % 2 === 0 ? '#22d3ee' : '#a78bfa'} initial={{
      opacity: 0.8
    }} animate={reduce ? undefined : {
      opacity: [0.45, 1, 0.45]
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: i * 0.2
    }} data-id="element-208" data-mp="34fjt1i129ff4" data-mpi={i} />)}

      <circle cx={CENTER.x} cy={CENTER.y} r="78" fill="#6366f1" opacity="0.45" filter="url(#orb-blur)" data-id="element-209" data-mp="3idguarqgma04" />
      <motion.circle cx={CENTER.x} cy={CENTER.y} r="92" fill="none" stroke="#22d3ee" strokeOpacity="0.35" strokeWidth="1" strokeDasharray="2 10" animate={reduce ? undefined : {
      rotate: 360
    }} transition={{
      duration: 40,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-210" data-mp="3n84jytx79aga" />
      <motion.circle cx={CENTER.x} cy={CENTER.y} r="56" fill="url(#orb-core)" animate={reduce ? undefined : {
      scale: [1, 1.04, 1]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-211" data-mp="50oivs4n4njt" />
      <circle cx={CENTER.x - 16} cy={CENTER.y - 20} r="12" fill="#ffffff" opacity="0.18" data-id="element-212" data-mp="1ghhmq4kjyfxv" />
    </svg>;
}